import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input } from '../general/forms/Input';
import { PasswordInput } from '../general/forms/PasswordInput';
import { Button } from '../general/Button';
import { Colors } from '../../styles/colors';
import { AppLogoHeader } from '../general/AppLogoHeader';
import { useShowConfirmationPopup } from '../../components/general/ConfirmationPopup';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100%;
`;

const LoginWrapper = styled.div`
   max-width: 100vw;
   width: 375px;
   padding: 3rem 1rem;
   margin: auto;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;

  margin-top: 2rem;
`;

const ButtonWrapper = styled.div`
  margin-top: 2.5rem;
  align-self: center;
`;

const InfoText = styled.p`
  color: ${Colors.grayMid};
  margin-top: 1rem;
  font-weight: 700;
  font-size: 1.125rem;
`;

interface Props {
  appName?: string;
  onResetPasswordClick: (password: string | null, passwordRepeat: string | null ) => void;
}

export const ResetPasswordForm: FC<Props> = (props) => {
  const { appName, onResetPasswordClick } = props;
  const showConfirmationPopup = useShowConfirmationPopup();
  const [password, setPassword] = useState<string | null>(null);
  const [passwordRepeat, setPasswordRepeat] = useState<string | null>(null);

  return (
    <Container>
      <LoginWrapper>
        <AppLogoHeader appName={appName}/>
        <InfoText>
          Bitte wählen Sie Ihr neues Password.
        </InfoText>

        <Form>
          <PasswordInput
            id={'password'}
            label={'Passwort'}
            value={password}
            onChange={(value) => {
              setPassword(value);
            }}
          />
          <PasswordInput
            id={'repeat-password'}
            label={'Passwort (bestätigen)'}
            value={passwordRepeat}
            onChange={(value) => {
              setPasswordRepeat(value);
            }}
          />
          <ButtonWrapper>
            <Button
              onClick={(event: React.FormEvent<HTMLButtonElement>) => {
                event.preventDefault();
                if(onResetPasswordClick) {
                  onResetPasswordClick(password, passwordRepeat);
                }
              }}>
              Password ändern
            </Button>
          </ButtonWrapper>
        </Form>
      </LoginWrapper>
    </Container>
  );
};
